const skillWeights = {
    "English": {
        "Ambiguity & Series": 0.0110117,
        "Apostrophes": 0.0254646,
        "Colons & Semicolons": 0.00619408,
        "Parenthetical Elements": 0.0467997,
        "Unnecessary Commas": 0.0509291,
        "Faulty Coordination & Subordination": 0.0470229,
        "Fragments & Fused Sentences": 0.0360019,
        "Misplaced Modifiers": 0.0345325,
        "Parallelism": 0.011021,
        "Participial Phrases": 0.0161641,
        "Relative Pronouns": 0.0183683,
        "Verb Tense & Pronoun Person": 0.0419821,
        "Adjectives & Adverbs": 0.0144529,
        "Comparatives & Superlatives": 0.00894701,
        "Confusing Pairs": 0.00550585,
        "Forming Verbs": 0.0103235,
        "Idiom": 0.00206469,
        "Prepositions": 0.026841,
        "Pronoun-Antecedent Agreement": 0.0399174,
        "Pronouns": 0.0185822,
        "Subject-Verb Agreement": 0.0247763,
        "Conjunctions": 0.0,
        "Redundancy": 0.0825877,
        "Style & Tone": 0.011,
        "Vague & Clumsy Writing": 0.0213352,
        "Word Choice": 0.053682,
        "Introductions & Conclusions": 0.0323469,
        "Paragraph Division": 0.00757054,
        "Paragraph Sequence": 0.00481762,
        "Sentence Placement": 0.0159,
        "Sentence Sequence": 0.0159,
        "Transitions": 0.0956641,
        "Accomplish Purpose": 0.044735,
        "Author's Purpose": 0.0729525,
        "Relevance": 0.0213352,
        "Writer's Goal": 0.0227116
    },
    "Math": {
        "Operations": 0.0552,
        "Percent": 0.0276,
        "Proportions": 0.0138,
        "Ratios": 0.0069,
        "Arithmetic": 0.1035,
        "Creating Expressions": 0.0185567,
        "Exponents & Roots": 0.0376289,
        "Expressions": 0.0134021,
        "Inequalities & Absolute Value": 0.0404,
        "Properties of Algebra": 0.0,
        "Slope": 0.0,
        "Solving Equations": 0.122165,
        "Equations: Coordinate Plane": 0.0,
        "Equations: Modeling & Relations": 0.0,
        "Creating Functions": 0.0185567,
        "Domain, Range, & Function": 0.0,
        "Function Graphs - Coordinate Plane": 0.0175258,
        "Function Graphs - Modeling & Relations": 0.0155,
        "Functions - Understanding & Evaluating": 0.035567,
        "Logarithms": 0.00773196,
        "Modeling": 0.0,
        "Patterns & Sequences": 0.0195876,
        "Properties of Functions": 0.0,
        "Trig Functions": 0.0123711,
        "Angles & Shapes": 0.0623711,
        "Area, Perimeter, Volume & Circumference": 0.11134,
        "Circles & Parabolas - Coordinate Plane": 0.0247423,
        "Circles - Plane Geometry": 0.0293814,
        "Slope, Midpoint & Distance": 0.0654639,
        "Logic": 0.0001,
        "Locating Points": 0.0,
        "Translation, Rotation, Reflection & Relative Equations": 0.0221649,
        "Triangles": 0.042268,
        "Trig Geometry": 0.0345361,
        "Using Formulas": 0.0,
        "Complex Numbers": 0.0,
        "Computation": 0.0,
        "Exponents & Place Value": 0.0128866,
        "Factors": 0.0159794,
        "Fractions": 0.0206186,
        "Matrices": 0.0,
        "Number Concepts & Properties": 0.0221649,
        "Number Line & Absolute Value": 0.0,
        "Averages, Median & Mode": 0.0237113,
        "Counting": 0.0159794,
        "Data Interpretation": 0.0180412,
        "Probability": 0.0159794,
        "Studies & Models": 0.0
    },
    "Reading": {
        "Analyze Word & Phrase Choices": 0.0620155,
        "Interpret Words & Phrases": 0.0930233,
        "Intent & Purpose": 0.0826873,
        "Point of View": 0.0310078,
        "Analyze Structure": 0.00516796,
        "Function": 0.0155039,
        "Relate to Passage as a Whole": 0.0310078,
        "Identifying Claims": 0.0439276,
        "Supporting Claims": 0.0645995,
        "Compare Two Texts": 0.0129199,
        "Conclusions Two Texts": 0.0,
        "Central Ideas & Themes": 0.0361757,
        "Summarize Key Ideas & Details": 0.136951,
        "Draw Conclusions": 0.111111,
        "Locate": 0.191214,
        "Paraphrase": 0.0310078,
        "Cause-Effect Relationships": 0.00775194,
        "Comparative Relationships": 0.0284238,
        "Sequence of Events": 0.0001,
        "Central Ideas": 0.0361757
    },
    "Science": {
        "Assumptions, Strengths & Weaknesses": 0.0102828,
        "Compare Models": 0.0179949,
        "Consistency of Hypotheses, Predictions & Conclusions": 0.0359897,
        "Model Information": 0.0257069,
        "New Information & Predictions in Models": 0.0257069,
        "Support of Hypotheses": 0.0745501,
        "Support or Weakening of Models": 0.0154242,
        "Compare or Combine": 0.0976864,
        "Creating Figures": 0.0514139,
        "Interpolation & Extrapolation": 0.0411311,
        "New Information": 0.0282776,
        "Select Data & Features": 0.267352,
        "Terminology": 0.0308483,
        "Text & Representations": 0.0411311,
        "Variables & Mathematical Relationships": 0.0514139,
        "Comparison": 0.00257069,
        "Control": 0.0179949,
        "Hypothesis": 0.00771208,
        "Methods": 0.00771208,
        "Precision & Accuracy": 0.00771208,
        "Prediction & Further Experiments": 0.0951157,
        "Text & Experiments": 0.0179949,
        "Tools": 0.00514139,
        "Understanding Design": 0.0231362
    }
}

export default skillWeights


// WEBPACK FOOTER //
// ./src/data/skillWeights.js